import { format } from 'date-fns';

export const wait = (ms: number) => {
  return new Promise((resolve) => {
    const t = setTimeout(() => {
      clearTimeout(t);
      resolve(null);
    }, ms);
  });
};

export const formatUnitAmount = (amount: number = 0, currency: string = 'usd') => {
  return formatUnitAmountCents(amount * 100, { currency });
};

export const formatUnitAmountCents = (amount = 0, options: Intl.NumberFormatOptions = {}) => {
  const price = Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: Number.isInteger(amount / 100) ? 0 : 2,
    ...options,
    currency: options?.currency || 'usd',
  });
  return price.format(amount / 100);
};

/**
 * Merge two arrays of objects by id.
 * The objects in the first array will take precedence over the objects in the second array.
 * If an object with the same id exists in both arrays, the object in the first array will be kept.
 * @param a The first array
 * @param b The second array
 * @returns A new array with the merged objects
 */
export function mergeArrayById<T>(a: Array<T & { id: number }>, b: Array<T & { id: number }>) {
  const reduced = a.filter((aItem) => !b.find((bItem) => aItem.id === bItem.id));
  return reduced.concat(b);
}

export const formatToDate = (datetime?: string | null, fmt: string = 'MM/dd/yyyy'): string|null => {
  if (!datetime) {
    return null;
  }
  return format(new Date(datetime), fmt);
};
